export default __webpack_public_path__ + "static/media/assetSample4@2x.5fe04d0b.png";